import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/en/translation.json";
import translationFR from "./locales/fr/translation.json";
import translationES from "./locales/es/translation.json";
import translationHI from './locales/hi/translation.json';
import translationBN from "./locales/bn/translation.json";
import translationGU from "./locales/gu/translation.json";
import translationMR from "./locales/mr/translation.json";
import translationTA from './locales/ta/translation.json';
import translationTE from "./locales/te/translation.json";
import translationKN from "./locales/kn/translation.json";
import translationML from './locales/ml/translation.json';

import translationJA from "./locales/ja/translation.json";
import translationZH from "./locales/zh/translation.json";
import translationVI from "./locales/vi/translation.json";
import translationNL from './locales/nl/translation.json';

import translationIT from "./locales/it/translation.json";
import translationTR from './locales/tr/translation.json';
import translationMS from "./locales/ms/translation.json";
import translationTH from "./locales/th/translation.json";
import translationID from './locales/id/translation.json';
import translationDE from "./locales/de/translation.json";
import translationARA from './locales/ara/translation.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: translationEN },
    fr: { translation: translationFR },
    es: { translation: translationES },
    hi: { translation: translationHI} ,
    mr: { translation: translationMR },
    gu: { translation: translationGU },
    bn: { translation: translationBN},
    ta: { translation: translationTA} ,
    te: { translation: translationTE },
    kn: { translation: translationKN },
    ml: { translation: translationML },
    ja: { translation: translationJA },
    zh: { translation: translationZH },
    vi: { translation: translationVI },
    nl: { translation: translationNL} ,
    it: { translation: translationIT },
    tr: { translation: translationTR},
    ms: { translation: translationMS} ,
    th: { translation: translationTH },
    id: { translation: translationID },
    de: { translation: translationDE },
    ara: { translation: translationARA },
    
  
  },
  lng: "en", // default language
  fallbackLng: "en", // fallback language if translation is missing
  interpolation: { escapeValue: false },
});

export default i18n;
